import { Checkbox, CheckboxProps } from '@mui/material';
import { BpCheckedIcon, BpIcon } from '@/components/blocks/DpCheckbox/style';

export const DpCheckbox: React.FC<CheckboxProps> = ({ ...props }) => (
	<Checkbox checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />
);
